import { notifyParent } from 'mailup-react-helpers'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { useRecoilCallback, useRecoilState, useSetRecoilState } from 'recoil'

import { ModalConfirm } from 'mailup-web-components'

import { changeWizardStepCallback } from 'Pages/Campaign/recoil/callbacks/callbacks'
import { modalConfirmIgnoreChangesState } from 'Pages/Campaign/recoil/state/modals'
import { pageState } from 'Pages/Campaign/recoil/state/page'

const ModalIgnoreChanges = () => {
  const intl = useIntl()
  const history = useHistory()

  const [{ show, redirectRoute }, setShow] = useRecoilState(
    modalConfirmIgnoreChangesState
  )
  const changeStep = useRecoilCallback(changeWizardStepCallback, [])
  const setPageState = useSetRecoilState(pageState)

  const onClickConfirm = () => {
    setPageState((prev) => ({
      ...prev,
      step2SelectTemplate: false,
      forceTemplates: false
    }))
    changeStep(1)
    setShow((prev) => ({ ...prev, show: false }))
    notifyParent('setFullScreen', [false])
    history.push(redirectRoute)
  }

  const onClickCancel = () => {
    setShow((prev) => ({ ...prev, show: false }))
  }

  return (
    <ModalConfirm
      show={show}
      showClose
      closeOnOverlayClick
      title={intl.formatMessage({ id: 'Load.Bee.ConfirmExitTitle' })}
      message={intl.formatMessage({
        id: 'Load.Bee.ConfirmExitDescription'
      })}
      variant='primary'
      stringConfirm={intl.formatMessage({ id: 'Load.MailupCommon.Yes' })}
      onClickConfirm={onClickConfirm}
      stringCancel={intl.formatMessage({ id: 'Load.MailupCommon.No' })}
      onClickCancel={onClickCancel}
    />
  )
}

export default ModalIgnoreChanges
